// ————————————————————————————————————————————— DOC. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

/**
 * @description Function to handle changes to the mode state.
 *              The mode state may be changed to one of the following values:
 *
 *              - "init"     → the component’s init. functions are about to be called
 *
 *              - "ready"    → all component’s init. functions have been called, but it is inactive
 *                           → interactions are disabled (no pointer events on entire component el.)
 *                           → scrolling is disabled (scroll instance is stopped)
 *
 *              - "active"   → the component is active;
 *                           → interactions are enabled
 *
 *              - "inactive" → interactions are disabled
 *
 *              The mode state changes at the occurence of the following events:
 *
 *              - "EVENTBUSCALL" → "inactive" when ...,
 *                               → "active" when ...,
 *
 * @param {Object} CHANGES - Object containing the changes to the mode state.
 **/

// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const loggerMsgs = {
  stateChange: (CHANGE) => [`mode: ${CHANGE}`],
  error_noStateChange: () => ["No change to mode state provided."],
  error_invalidStateValue: (VALUE) => [`Invalid state value: ${VALUE}`],
};

const possibleStateValues = ["init", "ready", "active", "inactive"];

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_mode(CHANGES) {
  if (!("mode" in CHANGES)) return this.logger("error", loggerMsgs.error_noStateChange(), "error");
  if (!possibleStateValues.includes(CHANGES.mode))
    return this.logger("error", loggerMsgs.error_invalidStateValue(CHANGES.mode), "error");

  // Setup...
  const { mode } = CHANGES;
  this.logger("state-change", loggerMsgs.stateChange(mode), "default", { inline: true });

  // [action]...
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
